import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

import { environment } from '../app/environments/environment';

/*
  Generated class for the TokenRefresh provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class TokenRefresh {
  private url = environment.api_url + 'api/token-refresh/';

  constructor(public http: Http) {
    console.log('Hello TokenRefresh Provider');
  }

  refresh(credentials): Observable<string> {
    return this.performTokenRefresh(credentials.token);
  }

  private performTokenRefresh(token: string): Observable<string> {
    let credentials = { token: token};
    return this.http.post(this.url, credentials)
      .map((res: Response) => {
        if (res.ok) { return this.handleRefreshSuccess(res); }
        else { return this.handleRefreshFail(res); }
        // return res.json();
      });
  }

  private handleRefreshSuccess(response: Response) {
    console.count('Token refresh succeeded');
    return response.json().token;
  }

  private handleRefreshFail(response: Response) {
    console.count('Token refresh failed');
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/providers/token-refresh.ts